import { useContext, ref } from '@nuxtjs/composition-api'
import { useLoading } from './ui/useLoading'
import { Brand } from '~/types/brand'

export const useBrand = () => {
  const loading = useLoading()
  const getBrandDetailLoading = useLoading()
  const brand = ref<Brand>()
  const brands = ref<Brand[]>([])
  const popularBrands = ref<Brand[]>([])

  const { app } = useContext()

  const getBrands = () => {
    return loading.scope(async () => {
      const response = await app.$api.brand.getBrands()
      brands.value = response
    })
  }

  const getPopularBrands = (limit: number) => {
    return loading.scope(async () => {
      const response = await app.$api.brand.getPopularBrands(limit)
      popularBrands.value = response
    })
  }

  const getByUrl = (url: string) => {
    return getBrandDetailLoading.scope(async () => {
      const response = await app.$api.brand.getBrandByUrl(url)
      brand.value = response
    })
  }

  return {
    brand,
    loading: loading.value,
    getBrandDetailLoading: getBrandDetailLoading.value,
    brands,
    popularBrands,

    getBrands,
    getByUrl,
    getPopularBrands,
  }
}
